import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { Col, Row, OverlayTrigger, Popover } from "react-bootstrap";
import styles from './Common.module.css';
import { ThemeButton } from '../../components/buttons/ThemeButton';
import NetworkManager from '../../app/managers/networkManager';
import { ProfilePictureEditor } from '../../components/collabs/ProfilePictureEditor';
import { setMyPhoto, removeMyPhoto, setPhotoEditorOpen } from '../../components/collabs/collabsSlice';
import logo from "../../assets/images/logo_main.png";
import planning from "../../assets/images/planning.png";
import groupes from "../../assets/images/groupes.png";
import collabs from "../../assets/images/collabs.png";
import contract from "../../assets/images/contracts-menu.png";
import settings from "../../assets/images/setting-lines.png";
import leaves from "../../assets/images/sunbed.png";
import timesheet from "../../assets/images/routine.png";
import reports from "../../assets/images/reports_icon.png";
import evaluation from '../../assets/images/evaluationMenu.png';
import vcomp from '../../assets/images/vcompIcon.png';
import vsec from '../../assets/images/vsec.png';
import permissionsIcon from '../../assets/images/permissionIcon.png';
import ventr from '../../assets/images/ventrIcon.png';
import clients from '../../assets/images/clientsMenuIcon.png';
import opportunities from '../../assets/images/exchange.png';
import medicalVisits from '../../assets/images/medicalVisit.png';
import dashboard from '../../assets/images/dashboard.png';
import dashboardUpdates from '../../assets/images/dashboardUpdates.png';
import { useDispatch, useSelector } from "react-redux";
import { setIsLoading, onPopupHandle, showPopup } from "./commonSlice";
import { logoutUser, resetUserSession } from "../login/loginSlice";
import { useMsal } from "@azure/msal-react";
import { checkPermission, isAdmin, isOwner } from '../../app/utils/helpers';
import Langs, { Localize } from '../../app/lang/langs';
import { setSelectedTeams } from "../../components/teams/teamsSlice";
import { config } from '../../app/utils/config';
import { MobileMenu } from './MobileMenu';

export function MenuBar() {

    const { instance } = useMsal();
    const popoverRef = useRef()
    const buttonRef = useRef()

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const urlParams = useParams()

    const loginType = useSelector((state) => state.login.loginType)
    const permissions = useSelector((state) => state.login.permissions)
    const confirmationTo = useSelector((state) => state.common.confirmationTo)
    const hasUpdates = useSelector((state) => state.common.hasUpdates)
    const email = useSelector((state) => state.login.userEmail)
    const username = useSelector((state) => state.login.userName)
    const userId = useSelector((state) => state.login.userId)
    const photoUpdatedAt = useSelector((state) => state.login.photoUpdatedAt)
    const photoEditorOpen = useSelector((state) => state.collabs.photoEditorOpen)
    const photoSaving = useSelector((state) => state.collabs.myPhotoSaving)
    const photoError = useSelector((state) => state.collabs.myPhotoError)
    const userRoleId = useSelector((state) => state.login.userRoleId)
    const userRoles = useSelector((state) => state.login.userRoles)
    const auto = useSelector((state) => state.login.auto)
    const idSubcontractor = useSelector((state) => state.login.idSubcontractor)
    const myTeam = useSelector((state) => state.teams.myTeam)
    const teams = useSelector((state) => state.teams.teams)
    const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)
    const defaultPage = useSelector((state) => state.common.defaultPage)
    const isMobile = useSelector((state) => state.settings.isMobile)

    const [showPopover, setShowPopover] = useState(false)
    const [menuItems, setMenuItems] = useState(getMenuButtons())

    function getMenuButtons() {
        return [
            {
                value: 'dashboard',
                label: 'Dashboard',
                image: dashboard,
                imageFocus: dashboard,
                imageUpdates: dashboardUpdates,
                visible: true,
                focused: true,
                subView: 0
            },
            {
                value: 'planning',
                label: 'Planning',
                image: planning,
                imageFocus: planning,
                visible: true,
                focused: false,
                subView: 0
            },
            {
                value: 'groupes',
                label: 'Groupes & Collabs',
                image: groupes,
                imageFocus: groupes,
                visible: checkPermission(config.scopes.groups, config.permissionTypes.view, selectedTeamsIds),
                focused: false,
                subView: 0
            },
            {
                value: 'collabs',
                label: 'Collabs & Suivis',
                image: collabs,
                imageFocus: collabs,
                visible: checkPermission(config.scopes.collabs, config.permissionTypes.view) || checkPermission(config.scopes.warnings, config.permissionTypes.view),
                focused: false,
                subView: checkPermission(config.scopes.collabs, config.permissionTypes.view) ? 0 : 1
            },
            {
                value: 'contracts',
                label: 'Contracts & Missions',
                image: contract,
                imageFocus: contract,
                visible: checkPermission(config.scopes.collabs, config.permissionTypes.view),
                focused: false,
                subView: 0
            },
            {
                value: 'reports',
                label: 'Reports',
                image: reports,
                imageFocus: reports,
                visible: isOwner(userRoleId) || checkPermission(config.scopes.reports, config.permissionTypes.view),
                focused: false,
                subView: 0
            },
            {
                value: 'evaluations',
                label: 'Evaluations',
                image: evaluation,
                imageFocus: evaluation,
                visible: checkPermission(config.scopes.evaluations, config.permissionTypes.view, selectedTeamsIds),
                focused: false,
                subView: 0
            },
            {
                value: 'timesheet',
                label: 'Timesheet',
                image: timesheet,
                imageFocus: timesheet,
                visible: auto && myTeam != null,
                focused: false,
                subView: 0
            },
            {
                value: 'leaves',
                label: 'Leaves',
                image: leaves,
                imageFocus: leaves,
                visible: true,
                focused: false,
                subView: 0
            },
            {
                value: 'vcomp',
                label: 'V-Comp',
                image: vcomp,
                imageFocus: vcomp,
                visible: checkPermission(config.scopes.vcomp, config.permissionTypes.view),
                focused: false,
                subView: 0
            },
            {
                value: 'ventr',
                label: 'V-Entr',
                image: ventr,
                imageFocus: ventr,
                visible: checkPermission(config.scopes.ventr, config.permissionTypes.view) || !idSubcontractor,
                focused: false,
                subView: 0
            },
            {
                value: 'clients',
                label: <Langs str='CLIENTS_TEAMS' />,
                image: clients,
                imageFocus: clients,
                visible: checkPermission(config.scopes.clientsTeams, config.permissionTypes.view),
                focused: false,
                subView: 0
            },
            {
                value: 'medicalVisits',
                label: <Langs str='MEDICAL_VISITS' />,
                image: medicalVisits,
                imageFocus: medicalVisits,
                visible: checkPermission(config.scopes.medicalVisits, config.permissionTypes.view),
                focused: false,
                subView: 0
            },
            {
                value: 'opportunities',
                label: <Langs str='OPPORTUNITIES' />,
                image: opportunities,
                imageFocus: opportunities,
                visible: checkPermission(config.scopes.opportunities, config.permissionTypes.view),
                focused: false,
                subView: 0
            },
            {
                value: 'vsecurite',
                label: <Langs str='VSEC_VIEW_TITLE' />,
                image: vsec,
                imageFocus: vsec,
                visible: true,
                focused: false,
                subView: 0
            },
            {
                value: 'permissions',
                label: <Langs str='PERMISSIONS_MANAGEMENT' />,
                image: permissionsIcon,
                imageFocus: permissionsIcon,
                visible: userRoleId == 1,
                focused: false,
                subView: 0
            },
            {
                value: 'settings',
                label: 'Settings',
                image: settings,
                imageFocus: settings,
                visible: true,
                focused: false,
                subView: 0
            }
        ]
    }

    useEffect(() => {
        setMenuItems(getMenuButtons())
    }, [teams, myTeam, userRoleId, auto, permissions, selectedTeamsIds])

    useEffect(() => {
        if (confirmationTo === "CONFIRM_LOGOUT") {
            dispatch(onPopupHandle())
            dispatch(setIsLoading(true))
            if (loginType === "MS") {
                const logoutRequest = {
                    account: instance.getAccountByUsername(email)
                }
                instance.logout(logoutRequest)
            }
            dispatch(logoutUser())
            dispatch(resetUserSession({ doReload: true }))
        }
    }, [confirmationTo])

    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (popoverRef.current && !popoverRef.current.contains(event.target) && !buttonRef.current.contains(event.target)) {
                setShowPopover(false)
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside)
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [popoverRef])

    useEffect(() => {
        if (urlParams.view) {
            menuItems.map(item => {
                if (item.value === urlParams.view) {
                    item.subView = urlParams.subView
                }
            })
            setMenuItems([...menuItems])
        }
    }, [urlParams])

    const handleShowPopover = () => {
        setShowPopover(!showPopover)
    }

    function handleLogout() {
        dispatch(showPopup({ show: true, title: "CONFIRM_LOGOUT", message: "CONFIRM_LOGOUT_MSG" }))
    }

    function setFocusedMenu(value, isFocused) {
        menuItems.map(item => {
            if (item.value === value) {
                item.focused = isFocused
            }
        })
        setMenuItems([...menuItems])
    }

    function setSelectedMenu(value) {
        let subview = 0
        menuItems.map(item => {
            if (item.value === value) {
                subview = item.subView
            }
        })
        let selectedTeamId = selectedTeamsIds[0]
        if (!selectedTeamId) {
            if (myTeam) selectedTeamId = myTeam.id
            else if (teams && teams[0]) selectedTeamId = teams[0].id
            if (selectedTeamId)
                dispatch(setSelectedTeams([selectedTeamId]))
        }
        navigate(`/${value}/${selectedTeamId}/${subview}`)
    }

    function getUsernameInitials() {
        if (username && username.length && username !== "null") {
            let array = username.split(" ")
            let initials = ""
            while (initials.length < 2 && array.length > 0) {
                let word = array.pop()
                initials += word.slice(0, 1)
            }
            return initials.toUpperCase()
        } else if (email) {
            return email.slice(0, 1).toUpperCase()
        }
    }

    // Null when the signed-in collab has no picture, which is what makes the button fall
    // back to initials. Versioned by photoUpdatedAt, so a new upload replaces it at once
    // while an unchanged one is served from cache.
    const myPhotoUrl = NetworkManager.getInstance().getCollabPhotoUrl(userId, photoUpdatedAt)

    function getRoleType() {
        if (typeof userRoleId != 'undefined')
            switch (parseInt(userRoleId)) {
                case 1:
                    return "Admin"
                case 2:
                    return "Manager"
                case 3:
                    return "Collab"
                default:
                    break;
            }
    }
    if (isMobile == 2) {
        return (
            <MobileMenu
                menuItems={menuItems}
                urlParams={urlParams}
                email={email}
                username={username}
                roleType={getRoleType()}
                getUsernameInitials={getUsernameInitials}
                onSelectMenu={setSelectedMenu}
                onLogout={handleLogout}
            />
        )
    }

    return <Col className={styles.menuBar}>
        <img className={styles.headerLogo}
            src={logo}
            alt={"logo"}
            onClick={() => setSelectedMenu(defaultPage)} />
        <div className={styles.menuList}>
            {
                (() => {
                    const visibleItems = menuItems.filter(item => item.visible)
                    const total = visibleItems.length
                    const mid = Math.ceil(total / 2)
                    return visibleItems.map((item, idx) => {
                        let image = item.image
                        if (urlParams.view && urlParams.view.toLowerCase() === item.value.toLowerCase()) {
                            image = item.imageFocus
                        }
                        if (item.imageUpdates && hasUpdates) {
                            image = item.imageUpdates
                        }
                        const isTopHalf = idx < mid
                        const stickyStyle = isTopHalf
                            ? { top: `${idx * 5}px`, zIndex: idx + 1 }
                            : { bottom: `${(total - 1 - idx) * 5}px`, zIndex: total - idx }
                        return <Row className={styles.menuItem}
                            key={"menu_" + item.value}
                            style={stickyStyle}>
                            <button className={styles.menuButton + " " + ((urlParams.view == item.value) ?
                                styles.selectedMenuButton : "")}
                                onMouseEnter={() => setFocusedMenu(item.value, true)}
                                onMouseLeave={() => setFocusedMenu(item.value, false)}
                                onClick={() => setSelectedMenu(item.value)}>
                                <img src={image}
                                    alt={item.value}
                                    width="30" />
                                <span className={styles.label}>
                                    <Langs str={item.label} />
                                </span>
                            </button>
                        </Row>
                    })
                })()
            }
        </div>
        <div className={styles.profileMenuFooter}>
            <OverlayTrigger
                show={showPopover}
                key={'top'}
                placement={'top'}
                overlay={
                    <Popover id='popover-positioned-top' style={{ zIndex: 1200, minWidth: '220px', border: 'none', borderRadius: '14px', overflow: 'hidden', boxShadow: '0 8px 32px rgba(0,0,0,0.14)' }}>
                        <Popover.Body ref={popoverRef} style={{ padding: 0 }}>
                            <div style={{
                                background: 'linear-gradient(135deg, #1a3c6e 0%, #2a6db5 100%)',
                                padding: '16px 16px 14px'
                            }}>
                                {/* Profile picture, with the control to change it. Clicking
                                    opens the crop dialog, which is mounted outside this
                                    popover — the popover closes on outside mousedown, and a
                                    dialog rendered in here would be unmounted with it. */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '10px' }}>
                                    <div
                                        onClick={() => dispatch(setPhotoEditorOpen(true))}
                                        title={Localize('PHOTO_EDIT_TITLE')}
                                        style={{
                                            width: '56px',
                                            height: '56px',
                                            borderRadius: '50%',
                                            flexShrink: 0,
                                            cursor: 'pointer',
                                            position: 'relative',
                                            background: myPhotoUrl ? 'transparent' : 'rgba(255,255,255,0.22)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: 'white',
                                            fontWeight: 700,
                                            fontSize: '18px',
                                            overflow: 'hidden',
                                            border: '2px solid rgba(255,255,255,0.35)',
                                        }}
                                    >
                                        {myPhotoUrl
                                            ? <img src={myPhotoUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                                            : getUsernameInitials()}
                                    </div>
                                    <div>
                                        <button
                                            onClick={() => dispatch(setPhotoEditorOpen(true))}
                                            style={{
                                                background: 'rgba(255,255,255,0.2)',
                                                border: 'none',
                                                color: 'white',
                                                fontSize: '12px',
                                                fontWeight: 600,
                                                padding: '5px 12px',
                                                borderRadius: '20px',
                                                cursor: 'pointer',
                                                display: 'block',
                                            }}
                                        >
                                            <Langs str={photoUpdatedAt ? "PHOTO_CHANGE_FILE" : "PHOTO_ADD"} />
                                        </button>
                                        {photoUpdatedAt ? (
                                            <button
                                                onClick={() => dispatch(removeMyPhoto())}
                                                disabled={photoSaving}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    color: 'rgba(255,255,255,0.75)',
                                                    fontSize: '11px',
                                                    padding: '4px 0 0 12px',
                                                    cursor: photoSaving ? 'default' : 'pointer',
                                                    textDecoration: 'underline',
                                                    display: 'block',
                                                }}
                                            >
                                                <Langs str="PHOTO_REMOVE" />
                                            </button>
                                        ) : null}
                                    </div>
                                </div>
                                {username && username !== "null" && (
                                    <div style={{ fontWeight: '700', fontSize: '15px', color: 'white', marginBottom: '4px' }}>
                                        {username}
                                    </div>
                                )}
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                    {(userRoles && userRoles.length ? userRoles : [getRoleType()]).map((role, i) => (
                                        <span key={i} style={{
                                            background: 'rgba(255,255,255,0.22)',
                                            color: 'white',
                                            fontSize: '11px',
                                            fontWeight: '600',
                                            padding: '2px 10px',
                                            borderRadius: '20px',
                                            letterSpacing: '0.5px',
                                            display: 'inline-block'
                                        }}>
                                            {role}
                                        </span>
                                    ))}
                                </div>
                            </div>
                            <div style={{ padding: '12px 16px 16px' }}>
                                <div style={{ fontSize: '12px', color: '#777', marginBottom: '12px', wordBreak: 'break-all' }}>
                                    {email}
                                </div>
                                <ThemeButton
                                    title="LOGOUT"
                                    active={true}
                                    onClick={() => handleLogout()}
                                />
                            </div>
                        </Popover.Body>
                    </Popover>
                }
            >
                <button
                    className={styles.userButton}
                    ref={buttonRef}
                    onClick={handleShowPopover}
                    // The gradient is the initials background; with a photo it would show as
                    // a rim around the circle, so it is dropped when one is present.
                    style={myPhotoUrl ? { background: 'none', padding: 0, overflow: 'hidden' } : undefined}>
                    {myPhotoUrl ? (
                        <img
                            src={myPhotoUrl}
                            alt={username && username !== "null" ? username : ""}
                            // Falls back to the initials if the picture ever fails to load,
                            // rather than leaving a broken-image icon in the menu.
                            onError={(e) => { e.currentTarget.style.display = 'none' }}
                            style={{
                                width: '100%',
                                height: '100%',
                                borderRadius: '50%',
                                objectFit: 'cover',
                                display: 'block',
                            }}
                        />
                    ) : getUsernameInitials()}
                </button>
            </OverlayTrigger>
        </div>
        {photoEditorOpen ? (
            <ProfilePictureEditor
                open={photoEditorOpen}
                saving={photoSaving}
                error={photoError}
                onClose={() => dispatch(setPhotoEditorOpen(false))}
                onSave={(dataUrl) => dispatch(setMyPhoto(dataUrl))}
            />
        ) : null}
    </Col>
}